import * as React from "react";
import { cn } from "../cn";

/**
 * The single page header for the whole app: one H1 scale (text-2xl), an optional
 * subtitle, and an optional right-aligned actions slot. Replaces the scattered
 * H1 sizes (lg..4xl) so every screen titles itself the same way.
 */
export function PageTitle({
  title,
  subtitle,
  actions,
  className,
  children,
}: {
  title: React.ReactNode;
  /** Quiet one-line context under the title. */
  subtitle?: React.ReactNode;
  /** Right-aligned actions (buttons, filters) on the title row. */
  actions?: React.ReactNode;
  className?: string;
  /** Extra content under the subtitle (e.g. breadcrumbs, status row). */
  children?: React.ReactNode;
}) {
  return (
    <header className={cn("flex flex-wrap items-start justify-between gap-x-6 gap-y-3", className)}>
      <div className="min-w-0">
        <h1 className="text-2xl font-semibold tracking-tight text-ink">{title}</h1>
        {subtitle && <p className="mt-1 text-sm text-mute">{subtitle}</p>}
        {children}
      </div>
      {actions && <div className="flex flex-shrink-0 items-center gap-2">{actions}</div>}
    </header>
  );
}
